// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import Typography from '@mui/material/Typography'
import { i18n } from '../../index'
import AddIncentiveButton from './AddIncentiveButton'
import type { StaffingPlanVariables, Incentives } from './types'

type Props = {
  salesIncentiveProducts: Array<Incentives>
  isPcs: boolean
  variables: StaffingPlanVariables
  registerIncentiveSale: (...args: Array<any>) => any
  unit: string | null | undefined
  stationId: string
}

class IncentiveProducts extends React.Component<Props> {
  render() {
    const { salesIncentiveProducts, isPcs, variables, registerIncentiveSale, stationId, date } = this.props
    const defaultPrices = [
      {
        tag: 'fixed-price-1',
        price: 1,
        innerTxt: '1 €',
      },
      {
        tag: 'fixed-price-0.5',
        price: 0.5,
        innerTxt: '0,5 €',
      },
      {
        tag: 'custom-price',
        innerTxt: 'Syötä summa',
      },
    ]
    const item_order = ['', 'Yleinen', 'Ravintola', 'Hesburger', 'Market', 'Muu']
    const sortedSalesIncentiveProducts = [...salesIncentiveProducts].sort(
      (a, b) => item_order.indexOf(a.category) - item_order.indexOf(b.category),
    )
    const products = [...sortedSalesIncentiveProducts, ...defaultPrices]
    // for different type of unit, there are different number of default incentive sales products set
    const defaultProductsLength = isPcs ? 1 : 3
    return (
      <React.Fragment>
        {products && products.length > defaultProductsLength ? ( // Create default and product-specific buttons in order to submit incentive sale values respectively
          products.map(({ id, tag, name, price, innerTxt, category }, i) => (
            <AddIncentiveButton
              stationId={stationId}
              key={`aib${i}`}
              tag={tag}
              salesIncentiveProductId={id}
              label={name}
              variables={variables}
              registerIncentiveSale={registerIncentiveSale}
              isPcs={isPcs}
              price={price}
              innerTxt={innerTxt}
              category={category}
              date={date}
            />
          ))
        ) : (
          <Typography variant='h6'>{i18n.t('employeeCard.addIncentiveSaleProducts')}</Typography>
        )}
      </React.Fragment>
    )
  }
}

export default IncentiveProducts
